import React from 'react';

import { cssMap } from '@compiled/react';

import { Box, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	card: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.150'),
		minHeight: '88px',
		width: '100%',
		boxSizing: 'border-box',
		paddingInlineStart: token('space.150'),
		paddingInlineEnd: token('space.150'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.large'),
		backgroundColor: token('elevation.surface'),
	},
});

export type SmartLinkCardSkeletonProps = {
	testId?: string;
};

export const SmartLinkCardSkeleton = ({
	testId,
}: SmartLinkCardSkeletonProps): React.JSX.Element => (
	<Box xcss={styles.card} testId={testId}>
		<Skeleton width={32} height={32} borderRadius={token('radius.small')} isShimmering />
		<Stack space="space.100">
			<Skeleton width={180} height={16} isShimmering />
			<Skeleton width={120} height={12} isShimmering />
		</Stack>
	</Box>
);
